import { observer } from 'mobx-react';
import { autoinject, inject, SubTopBar, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { AppStore } from '../Core/AppStore';
import { MainSettings } from './MainSettings';
import { WebApiSettings } from './WebApiSettings';
import { ZendeskSettings } from './ZendeskSettings';
import { AlertView } from './ContractExpirationAlerts/AlertView';

export interface IAdminViewProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class AdminView extends React.Component<IAdminViewProps> {
    public render() {
        return (
            <>
                <Title>Admin</Title>

                <SubTopBar>
                    <LinkContainer exact to="/admin" className="nav-link fw-bold d-inline-block">
                        <a className="btn btn-link">Main Settings</a>
                    </LinkContainer>

                    <LinkContainer
                        exact
                        to="/admin/contract-expiration-alerts"
                        className="nav-link fw-bold d-inline-block"
                    >
                        <a className="btn btn-link">Contract Expiration Alerts</a>
                    </LinkContainer>

                    <LinkContainer exact to="/admin/zendesk" className="nav-link fw-bold d-inline-block">
                        <a className="btn btn-link">Zendesk Settings</a>
                    </LinkContainer>

                    <LinkContainer exact to="/admin/web-api-kicks" className="nav-link fw-bold d-inline-block">
                        <a className="btn btn-link">WebApi Settings</a>
                    </LinkContainer>

                    <LinkContainer exact to="/noc-servers" className="nav-link fw-bold d-inline-block">
                        <a className="btn btn-link">Noc Servers</a>
                    </LinkContainer>
                </SubTopBar>

                <Route path="/admin" exact component={MainSettings} />
                <Route path="/admin/zendesk" component={ZendeskSettings} />
                <Route path="/admin/web-api-kicks" component={WebApiSettings} />
                <Route path="/admin/contract-expiration-alerts" component={AlertView} />
            </>
        );
    }

    @inject
    private appStore!: AppStore;
}
